import API from "./index"

export default {
  findAll(params) {
    return API.get("api/requisicoes-compra", { params })
  },
  findById(id) {
    return API.get(`api/requisicoes-compra/${id}`)
  },
  create(requisicaoCompra) {
    return API.post("api/requisicoes-compra", requisicaoCompra)
  },
  delete(id) {
    return API.delete(`api/requisicoes-compra/${id}`)
  },
  update(id, requisicaoCompra) {
    return API.put(`api/requisicoes-compra/${id}`, requisicaoCompra)
  },
  updateStatus(id, statusId) {
    return API.put(`api/requisicoes-compra/${id}/status`, null, { params: { statusId } })
  },
  findApproved(params) {
    return API.get("api/requisicoes-compra/aprovadas", { params })
  }
}
